// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"315":"ucare-panel-chunk","923":"ucare-widget-chunk"}[chunkId] || chunkId) + "." + {"283":"1abb3291","315":"6b30e95d","923":"3f7bd672"}[chunkId] + ".chunk.js";
};